import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { MoreHorizontal, X } from "lucide-react";

const slug = (s) => s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "-");

const Badge = ({ n }) => (n ? (
  <span className="absolute -right-2 -top-1 min-w-[16px] rounded-full bg-red-500 px-1 text-center text-[9px] font-bold leading-4 text-white ring-2 ring-white">{n === true ? "!" : n}</span>
) : null);

function Tab({ item }) {
  return (
    <NavLink to={item.to} end={item.end} data-testid={`tab-${slug(item.corto || item.label)}`}
      className={({ isActive }) => `relative flex flex-1 flex-col items-center gap-1 pb-1.5 pt-2 text-[10.5px] font-medium transition-colors ${isActive ? "text-vino-800" : "text-slate-500"}`}>
      {({ isActive }) => (
        <>
          <span className={`absolute top-0 h-[3px] w-8 rounded-b-full bg-vino-700 transition-opacity ${isActive ? "opacity-100" : "opacity-0"}`} />
          <span className={`relative flex h-7 w-12 items-center justify-center rounded-full transition-colors ${isActive ? "bg-vino-50" : ""}`}>
            <item.icon className="h-[20px] w-[20px]" strokeWidth={isActive ? 2.4 : 1.9} /><Badge n={item.badge} />
          </span>
          <span className="max-w-full truncate px-0.5">{item.corto || item.label}</span>
        </>
      )}
    </NavLink>
  );
}

function HojaMas({ items, extra, onClose }) {
  return (
    <div className="fixed inset-0 z-50 lg:hidden" data-testid="hoja-mas">
      <div className="absolute inset-0 bg-black/40 animate-fade-in" onClick={onClose} />
      <div className="hoja-mas-panel absolute inset-x-0 bottom-0 max-h-[80vh] overflow-y-auto rounded-t-3xl bg-white px-4 pb-[calc(env(safe-area-inset-bottom)+1rem)] pt-3 shadow-2xl">
        <div className="mx-auto mb-3 h-1.5 w-10 rounded-full bg-slate-200" />
        <div className="mb-3 flex items-center justify-between px-1">
          <p className="font-display text-base font-semibold text-slate-900">Más opciones</p>
          <button onClick={onClose} className="rounded-full p-1.5 text-slate-400 hover:bg-slate-100" data-testid="hoja-mas-cerrar" aria-label="Cerrar"><X className="h-5 w-5" /></button>
        </div>
        <div className="grid grid-cols-3 gap-2">
          {items.map((n) => (
            <NavLink key={`${n.to}-${n.label}`} to={n.to} end={n.end} onClick={onClose} data-testid={`mas-${slug(n.corto || n.label)}`}
              className={({ isActive }) => `relative flex flex-col items-center gap-2 rounded-2xl border p-3 text-center text-xs font-medium transition-colors ${isActive ? "border-vino-200 bg-vino-50 text-vino-800" : "border-slate-100 bg-slate-50 text-slate-700 active:bg-slate-100"}`}>
              <span className="relative flex h-10 w-10 items-center justify-center rounded-xl bg-white text-vino-700 shadow-sm"><n.icon className="h-5 w-5" /><Badge n={n.badge} /></span>
              <span className="leading-tight">{n.label}</span>
            </NavLink>
          ))}
        </div>
        {extra && <div className="mt-3">{extra}</div>}
      </div>
    </div>
  );
}

export function BarraMovil({ items, extra }) {
  const [abierto, setAbierto] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => { setAbierto(false); }, [pathname]);
  const cabe = items.length <= 5;
  const tabs = cabe ? items : items.slice(0, 4);
  const resto = cabe ? [] : items.slice(4);
  const restoActivo = resto.some((n) => (n.end ? pathname === n.to : pathname.startsWith(n.to)));
  const restoBadge = resto.some((n) => n.badge);
  return (
    <>
      <nav data-testid="barra-movil" className="fixed inset-x-0 bottom-0 z-40 flex border-t border-slate-200 bg-white/95 pb-[env(safe-area-inset-bottom)] shadow-[0_-4px_16px_rgba(0,0,0,0.05)] backdrop-blur-md lg:hidden">
        {tabs.map((n) => <Tab key={`${n.to}-${n.label}`} item={n} />)}
        {(resto.length > 0 || (extra && cabe)) && (
          <button onClick={() => setAbierto(true)} data-testid="tab-mas"
            className={`relative flex flex-1 flex-col items-center gap-1 pb-1.5 pt-2 text-[10.5px] font-medium ${restoActivo ? "text-vino-800" : "text-slate-500"}`}>
            <span className={`absolute top-0 h-[3px] w-8 rounded-b-full bg-vino-700 ${restoActivo ? "opacity-100" : "opacity-0"}`} />
            <span className={`relative flex h-7 w-12 items-center justify-center rounded-full ${restoActivo ? "bg-vino-50" : ""}`}><MoreHorizontal className="h-[20px] w-[20px]" /><Badge n={restoBadge} /></span>
            <span>Más</span>
          </button>
        )}
      </nav>
      {abierto && <HojaMas items={resto} extra={extra} onClose={() => setAbierto(false)} />}
    </>
  );
}
